import {
  IndustryHighlightsData,
  IndustryHighlightsVariant,
  IndustryHighlightsTestResult,
  UseIndustryHighlights,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "industryHighlights";

const useIndustryHighlights: UseIndustryHighlights = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: IndustryHighlightsData;
    variantCustomId: IndustryHighlightsVariant;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as IndustryHighlightsTestResult;
  }

  // Return the experiment result with proper typing
  const result = {
    isLoading: false,
    variant: value.variantCustomId,
    data: value.data,
  };

  return result;
};

export default useIndustryHighlights;
